import Route from "../../../router/Route";
import { RouterView, RouteLocationNormalized } from "vue-router";

import SchedulerOverview from "@/modules/scheduler/pages/SchedulerOverview.vue";
import SchedulerConfiguration from "@/modules/scheduler/pages/SchedulerConfigurationWrapper.vue";

import Configuration from "@/modules/scheduler/components/Configuration.vue";
import Recipients from "@/modules/scheduler/components/Recipients.vue";
import History from "@/modules/scheduler/components/History.vue";

export default new Route("scheduler", "/scheduler", RouterView, [
	new Route("scheduler.index", "", SchedulerOverview, [], {}),
	new Route(
		"scheduler.configuration",
		":schedule_uuid",
		SchedulerConfiguration,
		[
			new Route("schedule.configuration", "configuration", Configuration, []),
			new Route("schedule.recipients", "recipients", Recipients, []),
			new Route("schedule.history", "history", History, []),
		],
		{},
		(to: RouteLocationNormalized): string => {
			return `/scheduler/${to.params.schedule_uuid}/configuration`;
		}
	),
]);
